(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["comhar-size-specs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('comhar-size-specs')) {
  customElements.define('comhar-size-specs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-spec-size]')];
      this.selectSize = (size, focus = false) => {
        this.dataset.size = size;
        this.tabs.forEach(tab => {
          const active = tab.dataset.specSize === size;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.querySelector('#' + tab.getAttribute('aria-controls')).hidden = !active;
          if (active && focus) tab.focus();
        });
      };
      this.onClick = event => {
        const tab = event.target.closest('[data-spec-size]');
        if (tab) this.selectSize(tab.dataset.specSize);
      };
      this.onKey = event => {
        if (!event.target.matches('[data-spec-size]')) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const index = this.tabs.indexOf(event.target);
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? 1 : 1 - index;
        this.selectSize(this.tabs[next].dataset.specSize, true);
      };
      this.onProductChange = event => {
        if (!event.target.closest('variant-radios, variant-selects')) return;
        const picker = event.target.closest('variant-radios, variant-selects');
        const selected = [...picker.querySelectorAll('input[type="radio"]:checked, select')].map(input => input.value);
        const size = selected.find(value => /48.*24|55.*28/.test(value));
        if (size) this.selectSize(size.includes('55') ? '55' : '48');
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('change', this.onProductChange);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      document.removeEventListener('change', this.onProductChange);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
